import { render, staticRenderFns } from "./ServicesValueTab.vue?vue&type=template&id=3bab15cc&scoped=true&"
import script from "./ServicesValueTab.vue?vue&type=script&lang=js&"
export * from "./ServicesValueTab.vue?vue&type=script&lang=js&"
import style0 from "./ServicesValueTab.vue?vue&type=style&index=0&id=3bab15cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab15cc",
  null
  
)

export default component.exports